<template>
  <div class="introduce">
    <div class="tiltle">我们是谁</div>
    <div class="introduceLeft">
      <img src="@/assets/companybg1.png" alt="" />
      <div>
        <div>
          浙江良巧匠网络科技有限公司是一家专注于科技推广和应用服务领域的创新型企业。始终秉持“科技创新，服务为先”的经营理念，致力于通过先进的技术手段和优质的服务，为客户提供全面、高效的解决方案。目前，公司业务范围广泛，涵盖了技术服务、技术开发、技术咨询、技术转让、技术推广、互联网数据服务、工业互联网数据服务等多个领域。同时，公司还将积极拓展市场，加强与行业内外的合作与交流，共同推动专业技术领域的健康发展。
        </div>
        <div>
          同时为了进一步推进公司专业技术服务的合规化、数字化和协同化，我们打造了集精准匹配派发单、人员招聘、人才技能培训、就业指导、在线监管等全生命周期的智能化服务为一体的“民匠有约”服务平台。核心服务模型以平台审核特种作业人员持证信息真实性为基础，确保作业人员100%持证上岗，平台的证件验真授权、电子签约、考勤管理、考核管理、保险保障等一系列管理及风控措施，消除安全作业隐患。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.introduce {
  background: #ffffff;
  padding: 80px 360px;
  font-family: PingFang SC, PingFang SC;
  .tiltle {
    font-weight: 500;
    font-size: 28px;
    color: #141414;
  }
}
@media (max-width: 750px) {
  .introduce {
    padding: 80px 120px;
  }
}
.introduceLeft {
  font-weight: 400;
  font-size: 14px;
  text-align: left;
  line-height: 28px;
  color: #141414;
  display: flex;
  margin-top: 72px;
  div {
    margin-bottom: 30px;
  }
  img {
    width: 574px;
    height: 320px;
    margin-right: 52px;
  }
}
</style>
